import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setUserMsg } from '../../store/user'
import { RootState } from '../../store/configure-store'

const IconSuccess = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
    </svg>
)

const IconDanger = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
)

const IconClose = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
)

export const UserMsg = () => {
    const dispatch = useDispatch()
    const userMsg = useSelector((storeState: RootState) => storeState.users.msg)
    const timeoutId = useRef<NodeJS.Timeout>()

    useEffect(() => {
        if (timeoutId.current) clearTimeout(timeoutId.current)

        timeoutId.current = setTimeout(() => {
            onCloseMsg()
        }, 5000)

        return () => {
            clearTimeout(timeoutId.current)
        }
    }, [userMsg])

    const onCloseMsg = () => {
        clearTimeout(timeoutId.current)
        dispatch(setUserMsg({ msg: null }))
    }

    if (!userMsg) return <section className="user-msg"></section>

    return <section className={`user-msg open ${userMsg.type}`}>
        <span className="msg-icon">
            {userMsg.type === 'success' ? <IconSuccess /> : <IconDanger />}
        </span>
        <p className="msg-text">{userMsg.txt}</p>
        <button className="close-btn" onClick={(ev) => { ev.stopPropagation(); onCloseMsg() }}>
            <IconClose />
        </button>
    </section>
}
